import React from 'react';
import { Box, Typography, useTheme, alpha } from '@mui/material';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import { useTranslation } from 'react-i18next';

const CategoryFilter = ({ categories, selectedCategory, onChange }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (!categories || categories.length === 0) {
    return (
      <Box sx={{ py: 3, textAlign: 'center' }}>
        <LocalOfferOutlinedIcon sx={{ fontSize: 24, color: theme.palette.text.disabled, mb: 1 }} />
        <Typography variant="body2" sx={{ color: theme.palette.text.disabled }}>
          {t('news_hub.loading')}
        </Typography>
      </Box>
    );
  }

  const items = [{ value: null, label: t('news_category.all') }, ...categories.map(c => ({ value: c, label: t(`news_category.${c}`) }))];

  return (
    <Box data-tour="news-categories" sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <LocalOfferOutlinedIcon sx={{ fontSize: 16, color: theme.palette.text.disabled }} />
        <Typography
          variant="caption"
          sx={{ color: theme.palette.text.disabled, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}
        >
          {t('news_hub.categories_filter')}
        </Typography>
        {selectedCategory && (
          <Typography
            variant="caption"
            onClick={() => onChange(null)}
            sx={{
              ml: 'auto',
              color: theme.palette.primary.main,
              cursor: 'pointer',
              fontWeight: 500,
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            {t('news_hub.clear_filter')}
          </Typography>
        )}
      </Box>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      {items.filter(i => i.value !== null).map(({ value, label }) => {
        const isSelected = selectedCategory === value;
        return (
          <Box
            key={value ?? '__all__'}
            onClick={() => onChange(value)}
            sx={{
              px: 1.5,
              py: 0.875,
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.15s ease',
              fontSize: '0.875rem',
              fontWeight: isSelected ? 600 : 400,
              color: isSelected ? theme.palette.primary.main : theme.palette.text.secondary,
              backgroundColor: isSelected ? alpha(theme.palette.primary.main, 0.08) : 'transparent',
              '&:hover': {
                backgroundColor: isSelected
                  ? alpha(theme.palette.primary.main, 0.12)
                  : theme.palette.action.hover,
                color: isSelected ? theme.palette.primary.main : theme.palette.text.primary,
              },
            }}
          >
            {label}
          </Box>
        );
      })}
    </Box>
    </Box>
  );
};

export default CategoryFilter;
